module.exports = __webpack_public_path__ + "79ece181d956696c313bc9afde24466e.jpg";